/**
 * API Configuration
 * 
 * This file centralizes the API endpoint configuration for the application,
 * supporting multiple backend servers on different ports.
 */

// Add debugging for API configuration
console.log("Loading API configuration...");
console.log("Window location hostname:", window.location.hostname);
console.log("REACT_APP_API_URL:", process.env.REACT_APP_API_URL);

// API Configuration
const getApiBaseUrl = () => {
  // Check if we're in production and have the API URL environment variable
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In development, detect the environment
  const hostname = window.location.hostname;
  
  // If accessing via network IP (not localhost), use the same IP for backend
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    return `http://${hostname}:5050`;
  }
  
  // Default to localhost in development
  return 'http://localhost:5050';
};

// API endpoints
const API_ENDPOINTS = {
  PRICE: '/api/price',
  BOOKINGS: '/api/bookings',
  PING: '/ping'
};

// Common axios configuration
const axiosConfig = {
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
};

// The primary API endpoint (most services use this)
export const PRIMARY_API_URL = getApiBaseUrl();

// Log the configured PRIMARY_API_URL
console.log("PRIMARY_API_URL configured as:", PRIMARY_API_URL);

// The secondary API endpoint (for dashboard, analytics and selected endpoints)
export const SECONDARY_API_URL = PRIMARY_API_URL;

// Map of services to their respective API endpoints
export const API_SERVICES = {
  // All services now use the same port 5050
  DASHBOARD: PRIMARY_API_URL,
  ANALYTICS: PRIMARY_API_URL,
  FLEET: PRIMARY_API_URL,
  BOOKINGS: PRIMARY_API_URL,
  SETTINGS: PRIMARY_API_URL,
  USERS: PRIMARY_API_URL
};

/**
 * Returns the appropriate API URL for the given service
 * @param {string} service - The service name (e.g., 'FLEET', 'DASHBOARD')
 * @returns {string} The base URL for the service
 */
export const getApiUrl = (service) => {
  const url = PRIMARY_API_URL;
  console.log(`getApiUrl(${service}) => ${url}`);
  return url;
};

// Export a default object for convenience
export default {
  PRIMARY_API_URL,
  SECONDARY_API_URL,
  API_SERVICES,
  getApiUrl,
  getApiBaseUrl,
  API_ENDPOINTS,
  axiosConfig
};
